import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../../utils/scrollWithOffset";



const Nav = () => {
    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu">
                <li className="menu-item-has-children">
                    <HashLink to={process.env.PUBLIC_URL + "/#home"} scroll={scrollWithOffset(-90)}> 
                        Home
                    </HashLink>
                </li>

                <li className="menu-item-has-children">
                    <HashLink to={process.env.PUBLIC_URL + "/#our_values"} scroll={scrollWithOffset(-90)}> 
                        Our Values
                    </HashLink>
                </li>
               
                <li className="menu-item-has-children">
                    <HashLink to={process.env.PUBLIC_URL + "/#our_services"} scroll={scrollWithOffset(-90)}> 
                        Our Services
                    </HashLink>
                </li>

                <li className="menu-item-has-children">
                    <HashLink to={process.env.PUBLIC_URL + "/#industries"} scroll={scrollWithOffset(-90)}> 
                        Industries
                    </HashLink>
                </li>

            </ul>
        </nav>
    )
}

export default Nav;